import { Box, Image, Typography } from "@jewlr/storybook/core"
import PropTypes from "prop-types"
import styled from "styled-components"

import { jewlr_t } from "helpers/application"

const Border = styled(Box)`
  border: 1px solid ${(props) => props.theme.colors.black};
  padding: 32px 24px;
  ${(props) => props.theme.mediaQueries.tablet`
    padding: 56px 24px;
  `}
`

const StyledCard = styled(Box).attrs((props) => ({
  bg: "white",
  maxWidth: { tablet: "504px" },
  mx: "auto",
  p: "10px",
  width: "100%",
  ...props,
}))`
  @font-face {
    font-family: 'allura';
    src: url('${require("fonts/allura/allura-v8-latin-regular.woff2")}') format('woff2'),
        url('${require("fonts/allura/allura-v8-latin-regular.woff")}') format('woff'),
        url('${require("fonts/allura/allura-v8-latin-regular.ttf")}') format('truetype'),
        local("Helvetica"), local("Arial");
    font-weight: normal;
    font-style: normal;
    font-display: swap;
  }
  box-shadow: 3px 3px 9px ${(props) => props.theme.colors.neutral};
`

const Message = styled(Typography).attrs((props) => ({
  fontSize: { _: "24px", tablet: "32px" },
  ...props,
}))`
  font-family: "allura";
`

const Card = ({ data, ...props }) => (
  <StyledCard {...props}>
    <Border>
      <Box contain textAlign="center">
        {data.recipient_name && <Message>To: {data.recipient_name}</Message>}
        {data.gift_message ? (
          <>
            {data.gift_message.split("\n").map((line, index) => (
              <Message
                key={`msg_line_${line}`}
                mt={index == 0 && !data.recipient_name ? 8 : 2}
              >
                {line}
              </Message>
            ))}
          </>
        ) : (
          <>
            <Message mt={data.recipient_name ? 2 : 8}>Hey there,</Message>
            <Message mt={2}>
              Someone has {jewlr_t("terms.personalized")} a one-of-a-kind gift
              just for you.
            </Message>
            <Message mt={2}>
              We are handcrafting it in our {jewlr_t("terms.jewelry")} workshop
              and you will receive it soon.
            </Message>
            <Message mt={2}>Get excited!</Message>
          </>
        )}
        <Message mb="20px">{data.sender_name}</Message>

        <Image
          alt="Jewlr"
          height="64px"
          src={require("images/icons/jewlr_diamond.svg")}
          width="64px"
        />
      </Box>
    </Border>
  </StyledCard>
)

Card.propTypes = {
  data: PropTypes.object,
}

export default Card
